module.exports = __webpack_public_path__ + "static/EWY_Bilaal-ae3d48144c3b3fc7dbb61664b89bd23d.png";